import React from 'react'
import StarterPack from '../assets/images/starterpackstarterpack.png'

const HowToBuy = () => {
    return (
        <div className="dark:text-white flex flex-col items-center px-4">
            <h2 className="font-vt323 text-[44px] text-center mb-6">
                <u>$STARTER</u> STARTER PACK
            </h2>
            <img 
                src={StarterPack} 
                alt="$STARTER Starter Pack Meme" 
                className="w-full w-[1080px] rounded-md shadow-lg"
            />
        </div>
    );
}

export default HowToBuy;
